import { useTheme } from '@mui/material';
import { HTMLAttributes, useContext } from 'react';

import { LocaleContext } from '@/Contexts/LocaleContext';

function RequiredIndicator({ style, ...props }: HTMLAttributes<HTMLSpanElement>) {
  const theme = useTheme();
  const { translatedText } = useContext(LocaleContext);
  return (
    <span
      title={translatedText.common.requiredIndicatorTitle}
      aria-hidden='true'
      {...props}
      style={{
        position: 'relative',
        color: theme.palette.error.main,
        paddingLeft: '0.25rem',
        ...style,
      }}
    >
      *
    </span>
  );
}

export default RequiredIndicator;
